export const BASIC_VALUE_TOOLTIP = `
    <div>
      <p>
        Enter a value or use <code>{{ }}</code> to retrieve a value from the context using <b>JMESPath</b> selectors.
      </p>
      <p>
        The expression must return a <b>string</b> or <b>number</b>.
      </p>
      <div style={{ marginTop: 8 }}>
        <b>Examples:</b>
        <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
          <li>
            <code>{{@.number}}</code>
          </li>
          <li>
            <code>{{@.documents[0].name}}</code>
          </li>
          <li>
            <code>{{$row.name}}</code> - used in table row component
          </li>
           <li>
            <code>{{$item.id}}</code> - used in loop component, recursion component
          </li>
        </ul>
      </div>
    </div>`;

export const OPTIONS_VALUE_TOOLTIP = `
<p>
  Use the <b>Options</b> modal to configure preset values for the select field.
</p>
`;

export const BASIC_SELECT_VALUE_TOOLTIP = `
    <div>
      <p>
        Select one of the predefined values from the list.
      </p>
    </div>
  `;

export const JSON_LOGIC_SELECT_VALUE_TOOLTIP = `
<div>
    <p>
      Use the <b>JSON Logic UI Builder</b> to define a filter for the model instance API endpoint.
    </p>
    <p>
      You can always switch to JSON mode and write the <b>JSON Logic</b> expression manually.
    </p>
  </div>
`;

export const BASIC_SWITCH_VALUE_TOOLTIP = `
  <div>
    <p>
      Toggle the switch to set a <b>boolean</b> value.
    </p>
    <p>
      <b>Enabled</b> sets the value to <code>true</code>, while
      <b> disabled</b> sets the value to <code>false</code>, default value is <code>undefined</code>.
    </p>
  </div>
`;

export const BASIC_VARIABLE_TOOLTIP = `
    <div>
      <p>
        Select a value using the tree selector, or click the pencil icon to manually enter a
        <b> JMESPath</b> selector.
      </p>
      <p>
        The selected value can be of any type: <b>string</b>, <b>number</b>,
        <b>boolean</b>, <b>object</b>, or <b>array</b>.
      </p>
      <div style="margin-top: 8px;">
        <b>Examples:</b>
        <ul style="padding-left: 18px; margin-bottom: 0;">
          <li><code>@.number</code></li>
          <li><code>@.documents[0].name</code></li>
          <li><code>@.isActive</code></li>
          <li><code>@.documents</code></li>
        </ul>
      </div>
    </div>
  `;

export const BASIC_JSON_LOGIC_TOOLTIP = `
    <div>
    <p>
      Use <b>JSON Logic</b> to define a value based on other values from the context.
    </p>
    <p>
      The expression is evaluated against the current context and returns the resulting value.
    </p>
  </div>
`;

export const BASIC_TANSLATE_TOOLTIP = `
    <div>
    <p>
      Use <b>translate</b> to define a value. Use variable as {{@.name}} to connect with context variable.
    </p>
  </div>
`;

export const NAVIGATE_ON_SUCCESS_TOOLTIP = `
  <div>
    <p>Enter the path to navigate to after a successful action.</p>
    <p>You can use <code>{%  $response %}</code> to inject data from the API response into the URL.</p>
    <div style="margin-top: 8px;">
      <b>Examples:</b>
      <ul style="padding-left: 18px; margin-bottom: 0;">
        <li><code>/users</code></li>
        <li><code>/users/{% $response.id %}</code></li>
        <li><code>/orders/{% $response.orderId %}/details</code></li>
      </ul>
    </div>
  </div>
`;

export const BODY_TRANSFORMER_TOOLTIP = `
  <div>
    <p>Transform the request body before sending. You have access to:</p>
    <ul style="padding-left: 18px; margin-bottom: 8px;">
      <li><code>$form</code> — current form values</li>
      <li>All context data via JMESPath: <code>@.field</code>, <code>$instance.id</code></li>
    </ul>
    <div style="margin-top: 8px;">
      <b>Examples:</b>
      <ul style="padding-left: 18px; margin-bottom: 0;">
        <li><code>{ "payload": $form, modelInstanceId: $instance.id }</code></li>
        <li><code>{ "payload": merge($form, {status: 'ok'}) }</code></li>
      </ul>
    </div>
  </div>
`;

export const ON_SUCCESS_MESSAGE_TOOLTIP = `
  <div>
    <p>Message shown after a successful action.</p>
    <p>Use <code>{%  $response.field %}</code> to include data from the API response.</p>
    <div style="margin-top: 8px;">
      <b>Examples:</b>
      <ul style="padding-left: 18px; margin-bottom: 0;">
        <li><code>Record saved successfully!</code></li>
        <li><code>{% $response.name %} was created.</code></li>
        <li><code>Order #{% $response.id %} confirmed.</code></li>
      </ul>
    </div>
  </div>
`;

export const ON_ERROR_MESSAGE_TOOLTIP = `
  <div>
    <p>Message shown when the action fails.</p>
    <p>Use <code>{%  $error.field %}</code> to include details from the error.</p>
    <div style="margin-top: 8px;">
      <b>Examples:</b>
      <ul style="padding-left: 18px; margin-bottom: 0;">
        <li><code>Something went wrong. Please try again.</code></li>
        <li><code>Error: {% $error.message %}</code></li>
        <li><code>Failed with status {% $error.status %}.</code></li>
      </ul>
    </div>
  </div>
`;

export const CSS_COLOR_VALUE_TOOLTIP = `
  <div>
    <p>Choose a color or enter a custom CSS color value. Supported formats include:</p>
    <ul>
      <li>Hex: <code>#FF0000</code></li>
      <li>RGBA: <code>rgba(255, 0, 0)</code></li>
      <li>HSL: <code>hsl(0, 100%, 50%)</code></li>
    </ul>
  </div>
`;

export const BODY_TRANSFORMER_ITEMS_TOOLTIP = `
  <div>
    <p>
      Transform the data selected in <b>Items / Data</b>. The result must be an <b>array</b>.
    </p>
  </div>
`;

export const FIELD_NAME_TOOLTIP = `
  <div>
    <p>
    The schema key that uniquely identifies this field. Must be unique within the form.
  </p>
  <p>
    It is recommended to use field names from the data schema to avoid additional mapping.
  </p>
  </div>
`;

export const FIELD_REACTIONS_TOOLTIP = `
  <div>
    <p>
      Custom JavaScript-like logic that reacts to field value changes — use it to
      <b>show/hide</b>, <b>enable/disable</b>, or <b>set values</b> on other fields dynamically.
    </p>
  </div>
`;

export const BASIC_VALUE_RUNTIME_TEMPLATE_TOOLTIP = `
    <div>
      <p>
        Enter a value or use <code>{% %}</code> to retrieve a value from the context using <b>JMESPath</b> selectors.
      </p>
      <p>
        The expression must return a <b>string</b> or <b>number</b>.
      </p>
      <div style={{ marginTop: 8 }}>
        <b>Examples:</b>
        <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
          <li>
            <code>{% $row.data.number %}</code>
          </li>
          <li>
            <code>{% $row.data.documents[0].name %}</code>
          </li>
          <li>
            <code>{% join(', ', $row.data.roles[].name) %}</code> - used in table row component
          </li>
        </ul>
      </div>
    </div>`;
